export const topMockInterviews = [
    {
      id: 1,
      companyName: "Y Combinator",
      jobName: "YC Mock Interview (Startup Founder)",
      logo: "https://media.licdn.com/dms/image/v2/C4D0BAQGPzdBPNxrmEg/company-logo_100_100/company-logo_100_100/0/1673555093250/y_combinator_logo?e=1752710400&v=beta&t=ORVGOfpdIPZwDgDRVifYIR5vCx0x7D02NRPlIN70QRE",
      description: "This mock interview is designed for startup founders who have been invited to a YC interview. We will simulate a 15-minute call with 3–5 questions from YC’s database and follow up with feedback.",
      difficulty: "Hell-mode",
      duration: "15 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=6826c702e23c371ad732cb7f&companyName=Y Combinator&jobTitle=YC Mock Interview (Startup Founder)`,
    },
    {
      id: 2,
      companyName: "OpenAI",
      jobName: "Product Manager, Ecosystem",
      logo: "https://platform.theverge.com/wp-content/uploads/sites/2/2025/02/openai-new-logo_f252fc.png?quality=90&strip=all&crop=7.8125%2C0%2C84.375%2C100&w=2400",
      description: "Practice for OpenAI's technical and behavioral interviews for Product Manager roles",
      difficulty: "Hard",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db059db1e3a292c3e91f38&companyName=OpenAI&jobTitle=Product Manager, Ecosystem`,
    },
    {
      id: 3,
      companyName: "Reddit",
      jobName: "Senior Product Manager, User Economy",
      logo: "https://redditinc.com/hs-fs/hubfs/Reddit%20Inc/Brand/Reddit_Logo.png",
      description: "Prepare for Reddit's PM interview with questions focused on customer obsession",
      difficulty: "Medium",
      duration: "45 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db0843b1e3a292c3e91fc7&companyName=Reddit, Inc.&jobTitle=Senior Product Manager, User Economy`,
    },
    {
      id: 4,
      companyName: "LinkedIn",
      jobName: "Principal Product Manager - Trust LLM and Decisioning Platforms",
      logo: "https://cdn-icons-png.flaticon.com/512/174/174857.png",
      description: "Prepare for LinkedIn's PM interview with questions focused on customer obsession",
      difficulty: "Medium",
      duration: "50 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=684b74d80aeeecf5bf138132&companyName=LinkedIn&jobTitle=Principal Product Manager - Trust LLM and Decisioning Platforms`,
    },
    {
      id: 5,
      companyName: "Discord",
      jobName: "Product Manager, Player Experience",
      logo: "https://support.discord.com/hc/user_images/PRywUXcqg0v5DD6s7C3LyQ.jpeg",
      description: "Prepare for Discord's PM interview with questions focused on customer obsession",
      difficulty: "Medium",
      duration: "55 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db0b079fb7718de092eb3c&companyName=Discord&jobTitle=Product Manager, Player Experience`,
    },
    {
      id: 6,
      companyName: "Google",
      jobName: "Product Manager I, Generative AI, Google Cloud AI",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png",
      description: "Prepare for Google's PM interview with questions focused on customer obsession",
      difficulty: "Hard",
      duration: "60 min",
      questionCount: 15,
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db0bda9fb7718de092eb57&companyName=Google&jobTitle=Product Manager I, Generative AI, Google Cloud AI`,
    },
    {
      id: 7,
      companyName: "Notion",
      jobName: "Solutions Engineer",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Notion-logo.svg/2048px-Notion-logo.svg.png",
      description: "Practice for Notion's Solution Engineer interviews, covering technical problem-solving and customer-focused solutions.",
      difficulty: "Medium",
      duration: "40 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db0c7e9fb7718de092ec23&companyName=Notion&jobTitle=Solutions Engineer`,
    },
    {
      id: 8,
      companyName: "OpenAI",
      jobName: "Software Engineer, Full Stack (People Innovation)",
      logo: "https://platform.theverge.com/wp-content/uploads/sites/2/2025/02/openai-new-logo_f252fc.png?quality=90&strip=all&crop=7.8125%2C0%2C84.375%2C100&w=2400",
      description: "Practice for OpenAI's technical and behavioral interviews for Software Engineering roles",
      difficulty: "Hard",
      duration: "60 min",
      interviewLink: `${process.env.REACT_APP_FRONTEND_URL}/interview?QMJid=67db0cf89fb7718de092ec8a&companyName=OpenAI&jobTitle=Software Engineer, Full Stack (People Innovation)`,
    },
  ];